import React from "react";
import { Root, createRoot } from "react-dom/client";
import App from "./components/App";
import { Office } from "common";
import { BrowserRouter } from "react-router-dom";
import { ApiProvider, LoadingProvider } from "./providers";
import "./taskpane.css";

/* global module, require */

const rootElement: HTMLElement = document.getElementById("container");
const root: Root = createRoot(rootElement);

/* Render application after Office initializes */
Office.onReady(({ host }) => {
  window.oncontextmenu = (e: MouseEvent): void => {
    e.preventDefault();
  };

  const { pathname, search } = location;

  root.render(
    <BrowserRouter basename={`${pathname}${search}#`}>
      <LoadingProvider>
        <ApiProvider>
          <App host={host} />
        </ApiProvider>
      </LoadingProvider>
    </BrowserRouter>
  );
});

if ((module as any).hot) {
  (module as any).hot.accept("./components/App", () => {
    const NextApp = require("./components/App").default;
    root.render(NextApp);
  });
}
